/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
// libraries
import { Box, Stack, Dialog, Grid, Button, AppBar, Typography, Container, Slide, ButtonGroup } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import SimilarLeadWarningPopup from '../../sections/@dashboard/leadDetail/SimilarLeadWarningPopup';
import Steppers from '../steppers';
import Label from '../Label';
import { Iconify } from '../index';
import { useSettingsContext } from '../settings/context';
import { RenderActiveStep } from '../dialogPopUp';
import { FollowUp, AppointmentPage } from '../../sections/@dashboard/lead';
import { Activities } from '../../sections/@dashboard/leadDetail';
import { TreatmentAndAppointment, PersonalDetails, PaymentOption, MessageAndReminder } from '../../sections/@dashboard/general/app';
import { DentallyPaymentConfirmation } from '../dentally';
import { AttendedAppointment } from '../Attended';
import UnableToContact from '../failedToAttendTabs/UnableToContact';
import OpenContactLeadPopup from './OpenContactLeadPopup';
// store
import { useSelector, dispatch } from '../../redux/store';
import { updateSteps, updateBookingSteps, contactLeadSlice, updateActiveStep, updateFollowUpLead, setAttendedActiveTab, setCurrentTreatmentData, setDepositStatus, followUpSlice, getAppointment, tableLead, clearTaskLead, followUpLead as setFollowLead, leadFlowReminderData, startLoadingData, updateCompleteStatus } from '../../redux/slices/lead';
import { getActivities, reset as resetActivities } from '../../redux/slices/activity';
// styles
import { popupMainStackStyle, commonDialogHeaderStyle, onBoardDialogHeader, onBoardFooterButtonsStyle, leadFooterButtonsStyle, tabButtonBoxStyle, tabButtonGroupStyle, contactLeadButtonStyle, activeStepTitleStyle, activeStepTextStyle, footerButtonBoxStyle, backButtonStyle, nextButtonStyle, markAsCompleteButtonStyle, cancelBoxStyle, timelineButtonStyle, gridContainerStyle, dialogTypoStyle, cancelBtnDesign } from '../../styles/DialoguePopup';

const Transition = forwardRef((props, ref) => <Slide direction='up' ref={ref} {...props} />);

const OpenDialogPopup = ({ open, openArchivePopup, onClose, steps, type = 'lead', inputRef, user, updateStep, validStep, headerButtons, onboaradHeaderButtons, title, setActive, BookingAttendance, ContactedCount, timeLineCount }) => {
    const [activeStep, setActiveStep] = useState(0);
    const settings = useSettingsContext();
    const [outcome, setOutcome] = useState('Contact Lead');
    const { activeTab } = useSelector(state => state.singlePractice);
    const { practice } = useSelector(state => state.practice);
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const { isAppointmentBooked, archivedLead, attendedActiveTab, treatmentDepositStatus, treatmentLoading, isLoadingFinish, contactLead, attendance, followLead, BookingAttendance: bookingAttendanceState, newLeadDetail, isDentallyBooking, dentallyPatientId } = useSelector((state) => state.lead);
    const { dentallyEnabledGlobal } = useSelector((state) => state.practice);
    const { activityList } = useSelector((state) => state.activity);
    const [localSteps, setLocalSteps] = useState(steps || []);
    const [flowType, setFlowType] = useState(type);
    // Stable local selection to avoid being cleared by followUpSlice
    // Preserve selected lead across follow-up flow: fallback to followLead if personalDetail was overwritten
    const externalSelectedLead = newLeadDetail?.personalDetail?.existingLeadSelection || followLead || null;
    const [selectedLead, setSelectedLead] = useState(externalSelectedLead);
    const [internalFollowup, setInternalFollowup] = useState(false);
    const [embeddedContact, setEmbeddedContact] = useState(false);
    const [isLoadingSelectedLead, setIsLoadingSelectedLead] = useState(false);
    const displayedUser = useMemo(() => (flowType === 'followup' ? (selectedLead || user) : user), [flowType, selectedLead, user]);
    const isComplete = activeStep === (localSteps?.length || 0) - 1;

    const isPaymentMandatory = practice?.preferences?.is_payment_enforced_before_treatment;

    const selectStep = (index) => {
        switch (flowType) {
            case 'lead':
                dispatch(updateActiveStep(index));
                setActiveStep(index);
                break;
            case 'followup':
            case 'createLead':
                // Allow navigation across built steps in these flows as well
                dispatch(updateActiveStep(index));
                setActiveStep(index);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        dispatch(setAttendedActiveTab(''));
        dispatch(setCurrentTreatmentData(null));
        dispatch(setDepositStatus(false));
        dispatch(startLoadingData(false));
        dispatch(updateCompleteStatus(false));
        return () => {
            // on unmount, clear any persisted dropdown results
            try { dispatch(clearTaskLead()); } catch (e) { /* noop */ }
        };
    }, []);

    useEffect(() => {
        if (validStep) {
            if (activeStep !== (localSteps?.length || 0) - 1) {
                dispatch(updateActiveStep(activeStep + 1));
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setTimeout(() => {
                    updateStep(false);
                }, 1000);
            } else {
                updateStep(false);
                // For createLead flow, don't call handleClose here - it will be called
                // by the API success handler after createNewLead completes.
                // This prevents clearLead from being called before createNewLead reads the state.
                if (flowType !== 'createLead') {
                    handleClose();
                }
            }
        }
    }, [validStep, flowType]);

    useEffect(() => {
        if (BookingAttendance) {
            dispatch(updateActiveStep(activeStep + 1));
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }, [BookingAttendance]);

    useEffect(() => {
        if (setActive) setActive(activeStep);
    }, [activeStep]);

    const handleBack = () => {
        if (flowType === 'onboarad') {
            if (inputRef.current && inputRef.current.handleBack) {
                inputRef.current.handleBack();
                return;
            }
            dispatch(updateActiveStep(activeStep - 1));
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
            return;
        }
        if ((flowType === 'createLead' && activeStep < 2) || (flowType === 'followup' && activeStep <= 1)) {
            dispatch(updateSteps(null));
        }
        if (flowType === 'followup' && activeStep < 2) {
            dispatch(updateBookingSteps(null));
        }
        dispatch(updateActiveStep(activeStep - 1));
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = async (status) => {
        if (status === 'Archive') {
            status = 'Archive';
            await inputRef.current.submit(status);
            return;
        }
        if (activeStep === ((localSteps?.length || 0) - 1)) {
            status = 'finish';
        }
        await inputRef.current.submit(status);
    };

    const handleArchivePopup = () => {
        openArchivePopup();
        dispatch(updateFollowUpLead('archivedLead'));
    };

    const handleClose = () => {
        onClose();
        dispatch(updateActiveStep(0));
        setActiveStep(0);
        dispatch(contactLeadSlice(true));
        dispatch(startLoadingData(false));
        dispatch(updateCompleteStatus(false));
        setOutcome('Contact Lead');
        setFlowType(type);
        setSelectedLead(null);
        setLocalSteps(steps || []);
        setInternalFollowup(false);
        setEmbeddedContact(false);
        // Clear any persisted search results in store
        dispatch(clearTaskLead());
    };

    // Build follow-up steps in one place to avoid incremental appends
    const buildFollowupSteps = () => {
        const stepsArr = [];
        const first = contactLead
            ? <FollowUp ref={inputRef} handleNext={(ok) => updateStep(!!ok)} handleClose={handleClose} followLeadForScript={selectedLead} />
            : <Activities activityList={activityList?.results} notAllow />;
        stepsArr.push({ label: 'Contact', component: first });

        if (isAppointmentBooked) {
            const label = isAppointmentBooked;
            const component = isAppointmentBooked === 'Booking Details'
                ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={(ok) => updateStep(!!ok)} isOverview />
                : isAppointmentBooked === 'Unable to contact'
                    ? <UnableToContact ref={inputRef} handleNext={(ok) => updateStep(!!ok)} openArchivePopup={openArchivePopup} isOverview completeFlow={handleClose} />
                    : <AppointmentPage ref={inputRef} handleNext={(ok) => updateStep(!!ok)} />;
            stepsArr.push({ label, component });
        }
        if (attendance && isAppointmentBooked !== 'Appointment Not Booked') {
            if (attendance === 'attendance') {
                stepsArr.push({ label: 'Appointment Outcome', component: <AttendedAppointment ref={inputRef} handleNext={(ok) => updateStep(!!ok)} isOverview /> });
            } else {
                stepsArr.push({ label: 'Personal Details', component: <PersonalDetails ref={inputRef} handleNext={(ok) => updateStep(!!ok)} /> });
                stepsArr.push({ label: 'Payment options', component: <PaymentOption ref={inputRef} handleNext={(ok) => updateStep(!!ok)} /> });
                if (dentallyEnabledGlobal && isDentallyBooking) {
                    stepsArr.push({ label: 'Dentally Confirmation', component: <DentallyPaymentConfirmation ref={inputRef} handleNext={(ok) => updateStep(!!ok)} /> });
                }
                stepsArr.push({ label: 'Message review & reminders', component: <MessageAndReminder ref={inputRef} handleNext={(ok) => updateStep(!!ok)} type={'FollowUp'} /> });
            }
        }
        return stepsArr;
    };

    const activeBackButton = () => {
        switch (flowType) {
            case 'onboarad':
                return activeTab !== 'General' || activeStep !== 0;
            default:
                return activeStep !== 0;
        }
    };

    const leadHandler = (data) => {
        setOutcome(data);
        switch (data) {
            case 'Contact Lead':
                dispatch(contactLeadSlice(true));
                break;
            case 'Timeline':
                dispatch(contactLeadSlice(false));
                setActiveStep(0);
                dispatch(updateSteps(null));
                break;
            default:
                break;
        }
    };

    const getTitle = (value) => {
        switch (value) {
            case 'followup':
                if (activeStep === 0) {
                    return 'Contact';
                }
                switch (isAppointmentBooked) {
                    case 'Booking Details':
                        return 'Booking for';
                    case 'Unable to contact':
                        return 'Unable to contact';
                    default:
                        return 'Spoke - Not Booked —';
                }
            default:
                return '';
        }
    };

    const getButton = () => activeStep === ((localSteps?.length || 0) - 1) ? flowType === 'followup' && archivedLead ? 'Archive' : 'Finish' : 'Next';

    const isDisabledFinishButton = () => {
        if (isDentallyBooking && localSteps[activeStep]?.label === 'Dentally Confirmation' && !dentallyPatientId) {
            return true;
        }
        if (treatmentLoading) {
            return true;
        }
        if (getButton() === 'Finish' && isPaymentMandatory && (flowType === 'CreatedLead' || outcome === 'Contact Lead') && attendedActiveTab === 'Starting treatment' && !treatmentDepositStatus) {
            return true;
        }
        return false;
    };

    // Keep first step content in sync when toggling Contact Lead / Timeline during follow-up
    useEffect(() => {
        if (!(flowType === 'followup' && internalFollowup)) return;
        setLocalSteps(buildFollowupSteps());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contactLead, flowType]);

    // Append booking/attendance driven steps dynamically in follow-up mode
    useEffect(() => {
        if (!(flowType === 'followup' && internalFollowup)) return;
        setLocalSteps(buildFollowupSteps());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAppointmentBooked, attendance, flowType, internalFollowup]);

    // Sync steps prop → localSteps for the createLead flow so Dentally wizard
    // state changes (treatment/slot selection) propagate to the rendered step.
    useEffect(() => {
        if (flowType !== 'createLead') return;
        setLocalSteps(steps || []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [steps]);

    // derive match from personal details
    const normalizePhone = (p) => (p || '').replace(/[^0-9]/g, '');
    const phonesMatch = (a, b) => {
        const pa = normalizePhone(a);
        const pb = normalizePhone(b);
        if (!pa || !pb) return false;
        if (pa === pb) return true;
        const last10a = pa.slice(-10);
        const last10b = pb.slice(-10);
        return last10a === last10b || pa.endsWith(last10b) || pb.endsWith(last10a);
    };
    const canon = (s) => (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
    const matchParts = useMemo(() => {
        try {
            if (!selectedLead) return false;
            const pd = newLeadDetail?.personalDetail || {};
            const formFirstRaw = pd?.first_name || pd?.firstName;
            const formFirst = canon(formFirstRaw);
            const formLast = canon(pd?.last_name || pd?.lastName);
            const formPhoneRaw = pd?.lead_contact?.phone || pd?.phoneNumber;
            const leadFirstRaw = selectedLead?.first_name;
            const leadLastRaw = selectedLead?.last_name;
            const leadFirst = canon(leadFirstRaw);
            const leadLast = canon(leadLastRaw);
            const fullName = canon([leadFirst, leadLast].filter(Boolean).join(' '));
            const pa = normalizePhone(formPhoneRaw);
            const pb = normalizePhone(selectedLead?.lead_contact?.phone);
            const firstMatches = !!formFirst && (formFirst === leadFirst || formFirst === fullName);
            const lastMatches = leadLast ? (formLast === leadLast) : true;
            const phoneMatches = !!pa && !!pb && (pa === pb || pa.slice(-10) === pb.slice(-10) || pa.endsWith(pb.slice(-10)) || pb.endsWith(pa.slice(-10)));
            const result = firstMatches && lastMatches && phoneMatches;
            // debug logger removed to satisfy lint rules
            return { firstMatches, lastMatches, phoneMatches, result };
        } catch (e) { return { firstMatches: false, lastMatches: false, phoneMatches: false, result: false }; }
    }, [newLeadDetail?.personalDetail, selectedLead]);

    const hasExistingLeadMatch = matchParts.result;
    const [followUpEligible, setFollowUpEligible] = useState(false);
    // Persist eligibility across navigation unless user edits clear the selection
    const [stickyEligible, setStickyEligible] = useState(false);
    useEffect(() => {
        // Gate on first + last name + phone; any change flips eligibility off
        if (matchParts.firstMatches && matchParts.lastMatches && matchParts.phoneMatches) setFollowUpEligible(true);
        else setFollowUpEligible(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchParts.firstMatches, matchParts.lastMatches, matchParts.phoneMatches]);

    // Once eligible with a selected lead, keep the CTA sticky until the selection is cleared
    useEffect(() => {
        if (selectedLead && (hasExistingLeadMatch || followUpEligible)) setStickyEligible(true);
    }, [selectedLead, hasExistingLeadMatch, followUpEligible]);

    // If selection is cleared from PersonalDetails on edit, drop the sticky flag too
    useEffect(() => {
        if (!externalSelectedLead) setStickyEligible(false);
    }, [externalSelectedLead]);

    // Keep local selectedLead in sync when external selection appears
    useEffect(() => {
        // Mirror external selection; if cleared externally, clear locally too
        setSelectedLead(externalSelectedLead || null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [externalSelectedLead]);

    // Only preload lead data once user chooses to Follow up (embeddedContact=true)
    useEffect(() => {
        if (!embeddedContact || !selectedLead || !practiceId) return;
        dispatch(followUpSlice(selectedLead.id, practiceId));
        dispatch(getActivities(practiceId, selectedLead.id, 10, 0));
        dispatch(getAppointment(practiceId, selectedLead.id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [embeddedContact, selectedLead?.id, practiceId]);

    useEffect(() => {
        if (!isLoadingSelectedLead) return;
        if (embeddedContact && followLead && selectedLead && followLead.id === selectedLead.id) {
            setIsLoadingSelectedLead(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [embeddedContact, followLead, selectedLead, isLoadingSelectedLead]);

    const getSelectedLeadContactCount = () => {
        try {
            const arr = (followLead?.lead_treatments || selectedLead?.lead_treatments || []);
            const first = arr?.[0];
            const cnt = first?.lead_contacted_counts?.[0]?.count;
            return typeof cnt === 'number' ? cnt : null;
        } catch (e) { return null; }
    };

    const getActionLabel = () => 'Follow up';

    const buildTableRowFromFollowLead = () => {
        const base = followLead || selectedLead || {};
        const lt = (base?.lead_treatments || [])[0] || {};
        return {
            lead_id: base?.id,
            first_name: base?.first_name || '',
            last_name: base?.last_name || '',
            treatment_id: lt?.id || '',
            treatment_name: lt?.treatment || '',
            price: (lt?.custom_price ?? lt?.price ?? 0),
            custom_price: (lt?.custom_price ?? 0),
            leadTreatmentSpecification: lt?.leadtreatment_specification || lt?.leadTreatmentSpecification || null,
            treatmentData: base?.lead_treatments || [],
            status: lt?.status || '',
        };
    };

    return (
        <>
            <Dialog
                fullScreen
                TransitionComponent={Transition}
                open={open}
                onClose={handleClose}
                id='component-drawer'
                sx={{
                    zIndex: flowType === 'onboarad' ? 1117 : 1200,
                    margin: embeddedContact ? 0 : { xs: '0 -16px', sm: 0 },
                }}
            >
                {!embeddedContact && (
                    <AppBar sx={headerButtons ? commonDialogHeaderStyle : onBoardDialogHeader}>
                        <Typography
                            sx={dialogTypoStyle}
                            variant='h5'
                            component='div'
                        >
                            {displayedUser && flowType === 'onboarad' && `Welcome ${displayedUser && displayedUser.first_name} ${displayedUser && displayedUser.last_name}`} {title && title}
                            {displayedUser && getTitle(flowType)} {flowType === 'followup' && <span style={{ textTransform: 'capitalize' }}> {displayedUser && displayedUser.first_name} {displayedUser && displayedUser.last_name}</span>}
                        </Typography>
                        {flowType === 'createLead' && newLeadDetail?.personalDetail && (
                            <Box sx={{
                                display: 'flex', alignItems: 'center', gap: 1,
                                px: 1.5, py: 0.5, borderRadius: 1,
                                bgcolor: 'rgba(255,255,255,0.15)',
                            }}>
                                <Iconify icon='mdi:check-circle' width={18} sx={{ color: '#fff', flexShrink: 0 }} />
                                <Typography variant='subtitle2' sx={{ color: '#fff', whiteSpace: 'nowrap' }}>
                                    {newLeadDetail.personalDetail?.first_name || ''} {newLeadDetail.personalDetail?.last_name || ''}
                                    {(newLeadDetail.personalDetail?.lead_contact?.phone || newLeadDetail.personalDetail?.lead_contact?.email) ? ' — ' : ''}
                                    {newLeadDetail.personalDetail?.lead_contact?.phone || newLeadDetail.personalDetail?.lead_contact?.email || ''}
                                </Typography>
                            </Box>
                        )}
                        {flowType === 'onboarad' && <Typography
                            sx={dialogTypoStyle}
                            variant='h6'
                            component='div'
                        >
                            {displayedUser && flowType === 'onboarad' && "Let's get you started"}
                        </Typography>}
                        {(headerButtons || onboaradHeaderButtons) &&
                            <Box sx={cancelBoxStyle(onboaradHeaderButtons)}>
                                <Button
                                    color='inherit'
                                    variant='outlined'
                                    style={cancelBtnDesign}
                                    onClick={() => { handleClose('close'); }}
                                >
                                    Close
                                </Button>
                            </Box>
                        }
                    </AppBar>
                )}
                {!embeddedContact && (
                    <Stack spacing={0} sx={popupMainStackStyle}>
                        <Grid container spacing={1} sx={{ width: '100%', ml: 'auto', flex: 1, overflowY: 'auto', alignContent: 'flex-start' }}>
                            <Container
                                maxWidth={settings.themeStretch ? false : 'xl'}
                            >
                                <Grid container justifyContent={isComplete ? 'center' : 'flex-start'} sx={flowType === 'followup' && ContactedCount !== 0 && activeStep === 0 && gridContainerStyle(flowType, ContactedCount, activeStep)}>
                                    {!embeddedContact && (
                                        <Grid item xs={12} md={12} sx={{ mb: 2, mt: 1 }}>
                                            <Steppers
                                                steps={localSteps}
                                                activeStep={activeStep}
                                                isComplete={isComplete}
                                                selectStep={selectStep}
                                            />
                                        </Grid>
                                    )}
                                    {flowType === 'followup' && activeStep === 0 && <SimilarLeadWarningPopup type={'DialogPopup'} dialogClose={() => handleClose('close')} />}
                                    {flowType === 'followup' && ContactedCount !== 0 && activeStep === 0 && (
                                        <Box sx={tabButtonBoxStyle}>
                                            <ButtonGroup sx={tabButtonGroupStyle}>
                                                <Button
                                                    name={'state'}
                                                    onClick={() => leadHandler('Contact Lead')}
                                                    sx={contactLeadButtonStyle(outcome)}
                                                >Contact Lead</Button>
                                                <Button
                                                    name={'state'}
                                                    onClick={() => leadHandler('Timeline')}
                                                    sx={timelineButtonStyle(outcome)}
                                                ><Label color={outcome === 'Timeline' ? 'info' : 'default'} sx={{ marginRight: '10px' }} > {timeLineCount || 0} </Label> Timeline </Button>
                                            </ButtonGroup>

                                        </Box>
                                    )}

                                    {!embeddedContact && localSteps[activeStep] && localSteps[activeStep].title ?
                                        <Box sx={activeStepTitleStyle}>
                                            <Typography variant='h3'>{localSteps[activeStep].title}</Typography>
                                        </Box>
                                        : ''}
                                    {!embeddedContact && localSteps[activeStep] && localSteps[activeStep].bodyText ?
                                        <Box sx={activeStepTextStyle}>
                                            <Typography variant='body'>{localSteps[activeStep].bodyText}</Typography>
                                        </Box>
                                        : ''}
                                    <Grid item xs={12} md={12} sx={{ mb: 2 }} ariaLabel='popup-form-container' >
                                        {!embeddedContact && localSteps[activeStep] && RenderActiveStep({ component: localSteps[activeStep].component, inputRef })}
                                        {embeddedContact && (
                                            <OpenContactLeadPopup
                                                embed
                                                open
                                                onClose={handleClose}
                                                openArchivePopup={openArchivePopup}
                                                user={{ ...(selectedLead || {}), lead_id: (selectedLead?.lead_id || selectedLead?.id) }}
                                                steps={localSteps}
                                                type={'followup'}
                                                validStep={validStep}
                                                BookingAttendance={BookingAttendance}
                                                updateStep={updateStep}
                                                inputRef={inputRef}
                                                ContactedCount={getSelectedLeadContactCount()}
                                            />
                                        )}
                                    </Grid>
                                    {(() => {
                                        const currentStep = localSteps[activeStep];
                                        const isFooterHidden = currentStep?.hideFooter || currentStep?.hideFooterOnSuccess;
                                        return !embeddedContact && !isFooterHidden && (flowType === 'followup' && activeStep === 0 ? null : <Box
                                            className='buttons-box'
                                            sx={footerButtonBoxStyle}
                                        >
                                            <Container
                                                maxWidth={settings.themeStretch ? false : 'xl'}
                                                sx={(
                                                    flowType === 'createLead' || flowType === 'followup'
                                                        ? leadFooterButtonsStyle(activeBackButton(), flowType)
                                                        : onBoardFooterButtonsStyle(activeBackButton())
                                                )}
                                                className='buttons-container'
                                            >
                                                {activeBackButton() && (
                                                    <Button
                                                        color='inherit'
                                                        variant='outlined'
                                                        disabled={!activeBackButton()}
                                                        onClick={handleBack}
                                                        className='back-button'
                                                        sx={backButtonStyle(flowType)}
                                                    >
                                                        Back
                                                    </Button>
                                                )}
                                                <Box className='buttons-right'>
                                                    {
                                                        flowType === 'followup' && ContactedCount > 2 && isAppointmentBooked === 'Unable to contact' && (<Button
                                                            color='primary'
                                                            variant='outlined'
                                                            onClick={handleArchivePopup}
                                                            className='finish-button'
                                                            sx={nextButtonStyle(flowType)}
                                                        >
                                                            Archive
                                                        </Button>)
                                                    }
                                                    {
                                                        (flowType === 'followup' && activeStep === 0) || (flowType === 'createLead' && activeStep === 0 && (followUpEligible || stickyEligible)) ? null : (
                                                            currentStep?.buttonLoading ? (
                                                                <LoadingButton
                                                                    loading
                                                                    variant='contained'
                                                                    className='finish-button'
                                                                    sx={{ ...nextButtonStyle(flowType), bgcolor: 'primary.main', color: 'white', '&:hover': { bgcolor: 'primary.dark' } }}
                                                                >
                                                                    {currentStep?.buttonLabel || getButton()}
                                                                </LoadingButton>
                                                            ) : (
                                                                <LoadingButton
                                                                    color='primary'
                                                                    variant={currentStep?.buttonLabel ? 'contained' : 'outlined'}
                                                                    loading={isLoadingFinish}
                                                                    loadingPosition='start'
                                                                    onClick={() => handleNext()}
                                                                    className='finish-button'
                                                                    sx={currentStep?.buttonLabel ? { ...nextButtonStyle(flowType), bgcolor: 'primary.main', color: 'white', '&:hover': { bgcolor: 'primary.dark' } } : nextButtonStyle(flowType)}
                                                                    disabled={currentStep?.buttonDisabled || isDisabledFinishButton()}
                                                                    startIcon={currentStep?.buttonIcon ? <Iconify icon={currentStep.buttonIcon} width={18} /> : null}
                                                                >
                                                                    {currentStep?.buttonLabel || getButton()}
                                                                </LoadingButton>
                                                            )
                                                        )
                                                    }
                                                    {flowType === 'createLead' && activeStep === 0 && (followUpEligible || stickyEligible) && (
                                                        <LoadingButton
                                                            variant='contained'
                                                            color='primary'
                                                            loading={isLoadingSelectedLead}
                                                            onClick={() => {
                                                                // Seed followLead with the newly selected lead for immediate default display
                                                                try { if (selectedLead?.id) dispatch(setFollowLead({ ...selectedLead })); } catch (e) { /* noop */ }
                                                                // Clear previous activity and reminders/notes to avoid stale flashes
                                                                try { dispatch(resetActivities()); } catch (e) { /* noop */ }
                                                                try { dispatch(leadFlowReminderData({ results: [], count: 0 })); } catch (e) { /* noop */ }
                                                                // Signal that we're following up on an existing lead so
                                                                // CreateLeadDialogWrapper does NOT fire createNewLead()
                                                                dispatch(updateFollowUpLead('followUp'));
                                                                dispatch(updateSteps(null));
                                                                dispatch(updateBookingSteps(null));
                                                                setFlowType('followup');
                                                                setInternalFollowup(true);
                                                                try { dispatch(tableLead(buildTableRowFromFollowLead())); } catch (e) { /* empty */ }
                                                                setLocalSteps(buildFollowupSteps());
                                                                setActiveStep(0);
                                                                dispatch(updateActiveStep(0));
                                                                setIsLoadingSelectedLead(true);
                                                                setEmbeddedContact(true);
                                                            }}
                                                            sx={{ ml: 2, minWidth: { xs: 180, sm: 220 }, px: 4, py: 1.25 }}
                                                        >
                                                            {getActionLabel()}
                                                        </LoadingButton>
                                                    )}
                                                    {(activeStep >= 1 && activeStep !== ((localSteps?.length || 0) - 1)) && flowType !== 'onboarad' && !isDentallyBooking && !(flowType === 'createLead' && dentallyEnabledGlobal) &&
                                                        <LoadingButton
                                                            color='primary'
                                                            variant='contained'
                                                            loading={isLoadingFinish}
                                                            loadingPosition='start'
                                                            onClick={() => handleNext('finish')}
                                                            className='mark-complete-button'
                                                            sx={markAsCompleteButtonStyle(flowType)}
                                                        >
                                                            Mark As Complete
                                                        </LoadingButton>
                                                    }
                                                </Box>
                                            </Container>
                                        </Box>);
                                    })()}
                                </Grid>
                            </Container>
                        </Grid>
                    </Stack>
                )}
                {embeddedContact && (
                    <OpenContactLeadPopup
                        embed
                        onBackEmbed={() => {
                            // Return to search step
                            setEmbeddedContact(false);
                            setFlowType('createLead');
                            setActiveStep(0);
                            dispatch(updateActiveStep(0));
                            // reset locally constructed follow-up steps to original createLead steps
                            setLocalSteps(steps || []);
                            // reset follow-up specific state
                            dispatch(updateSteps(null));
                            dispatch(updateBookingSteps(null));
                            dispatch(contactLeadSlice(true));
                            dispatch(clearTaskLead());
                            // Clear follow-up flag so createLead flow can work again if needed
                            dispatch(updateFollowUpLead(null));
                        }}
                        open
                        onClose={handleClose}
                        openArchivePopup={openArchivePopup}
                        user={{ ...(selectedLead || {}), lead_id: (selectedLead?.lead_id || selectedLead?.id) }}
                        steps={localSteps}
                        type={'followup'}
                        validStep={validStep}
                        BookingAttendance={bookingAttendanceState}
                        updateStep={updateStep}
                        inputRef={inputRef}
                        ContactedCount={getSelectedLeadContactCount()}
                    />
                )}
            </Dialog>
        </>
    );
};

export default OpenDialogPopup;

OpenDialogPopup.propTypes = {
    open: PropTypes.bool,
    openArchivePopup: PropTypes.func,
    onClose: PropTypes.func,
    steps: PropTypes.array,
    type: PropTypes.string,
    title: PropTypes.string,
    inputRef: PropTypes.object,
    user: PropTypes.object,
    BookingAttendance: PropTypes.any,
    updateStep: PropTypes.func,
    validStep: PropTypes.bool,
    headerButtons: PropTypes.bool,
    onboaradHeaderButtons: PropTypes.bool,
    setActive: PropTypes.func,
    ContactedCount: PropTypes.number,
    timeLineCount: PropTypes.number,
};
